import * as React from "react";
import Checkbox from "../../CheckboxNew";
import Input from "../../Input-new/Input";

const PropertyFinancials = ({isAgent, data, handleChangeInput, openFinancialsSpreadsheet, viewMode, deleted, isFinancing}) => {
    return (
        <div className="Property-financials">
            {
                !isFinancing &&
                <div className="Property-financials_actions">
                    <button type='button'
                            className="button-new positive"
                            onClick={openFinancialsSpreadsheet}
                    >
                        View Financials
                    </button>
                    <Checkbox
                        text="HIDE FINANCIALS"
                        type={viewMode ? "uncheckable" : "checkable"}
                        isSelected={data.HIDE_FINANCIALS}
                        handleClick={handleChangeInput}
                        name="HIDE_FINANCIALS"
                    />
                </div>
            }
            <div className="Property-financials_column">
                {
                    isFinancing ?
                        <Input
                            className="Property-financials_column_item"
                            type="text"
                            valueType="integer"
                            name="HSC_PRICE"
                            label="Price"
                            value={data.HSC_PRICE}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar
                        />
                        :
                        <Input
                            className="Property-financials_column_item"
                            type="text"
                            valueType="integer"
                            name="LIST_PRICE"
                            label="List Price"
                            value={data.LIST_PRICE}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar
                        />
                }
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="percent"
                    name="CAPITALIZATION_RATE"
                    label="Cap Rate"
                    value={data.CAPITALIZATION_RATE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="integer"
                    name="NET_OPERATING_INCOME"
                    label="NOI"
                    value={data.NET_OPERATING_INCOME}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                {
                    data.TYPE === 'MT' &&
                    <Input
                        className="Property-financials_column_item"
                        type="text"
                        valueType="integer"
                        name="BASE_RENT"
                        label="Base Rent"
                        value={data.BASE_RENT}
                        disabled={isAgent}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                }
            </div>
            <div className="Property-financials_column">
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="float"
                    name="PRICE_PER_SQFT"
                    label="PSF – auto"
                    value={data.PRICE_PER_SQFT}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                {
                    data.TYPE === 'MT' &&
                    <Input
                        className="Property-financials_column_item"
                        type="text"
                        valueType="percent"
                        name="VACANCY"
                        label="Occupancy"
                        value={data.VACANCY}
                        disabled={isAgent}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="float"
                    name="RENT_PER_SQFT"
                    label="Rent/Sq Ft – auto"
                    value={data.RENT_PER_SQFT}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
            </div>
        </div>
    );
};

export default PropertyFinancials;
